import type { SVGProps } from "react";

export default function DocumentAnalysisIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 19 19"
      fill="none"
      {...props}
    >
      <path
        d="M16.925 10.7165L17.3564 9.10658C17.8599 7.22737 18.1117 6.28775 17.9221 5.47461C17.7724 4.83256 17.4357 4.24932 16.9545 3.79864C16.3451 3.22787 15.4054 2.97611 13.5263 2.47257C11.647 1.96902 10.7074 1.71726 9.89428 1.90686C9.2522 2.05656 8.66895 2.39329 8.21829 2.87447C7.72961 3.39623 7.47476 4.16006 7.09554 5.54842C7.03186 5.78158 6.96466 6.03236 6.89226 6.30256L6.46085 7.91261C5.95731 9.79183 5.70554 10.7314 5.89514 11.5446C6.04484 12.1867 6.38157 12.7699 6.86276 13.2206C7.47216 13.7913 8.41178 14.0431 10.291 14.5467C11.9849 15.0005 12.9153 15.2498 13.6779 15.1557C13.7614 15.1455 13.8428 15.1311 13.923 15.1123C14.565 14.9627 15.1483 14.6259 15.5989 14.1447C16.1697 13.5353 16.4215 12.5957 16.925 10.7165Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M13.6785 15.1552C13.5048 15.6873 13.1993 16.1686 12.7885 16.5533C12.1791 17.1241 11.2394 17.3758 9.36026 17.8794C7.481 18.3829 6.54138 18.6347 5.72823 18.4451C5.08619 18.2954 4.50295 17.9587 4.05227 17.4775C3.48151 16.8681 3.22974 15.9285 2.7262 14.0493L2.29483 12.4393C1.79129 10.5601 1.53952 9.62051 1.72912 8.80734C1.87882 8.16532 2.21556 7.58208 2.69674 7.1314C3.30614 6.56063 4.24576 6.30887 6.12499 5.80533C6.48052 5.71006 6.80241 5.62381 7.09619 5.54785"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M9.81299 8.51025L13.8377 9.58867"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M9.16553 10.9246L11.5804 11.5716"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
